<template>
    <v-card style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;">
        <v-toolbar flat>
            Filtros
            <v-spacer></v-spacer>
            <v-btn id="seeFilters" fab text small @click.native="seeFilters = !seeFilters">
                <v-icon dark small v-if="seeFilters">fas fa-angle-up</v-icon>
                <v-icon dark small v-else>fas fa-angle-down</v-icon>
            </v-btn>
        </v-toolbar>
        <v-spacer></v-spacer>
        <v-layout v-if="seeFilters">
            <slot/>
        </v-layout>
    </v-card>
</template>

<script>

export default {
    props: {

    },
    data() {
        return{
            seeFilters: true
        }
    },
    methods: {

    }
}
</script>

<style>
    .margin {
        margin-bottom: 1%;
    }
</style>